import wishlist from '../store/wishlist';
import { formatMoney } from './common';
import lang from '../lang/language';
import { getDetailsUrl, getLanguage, getUrlParam } from './url';
let Map = null;
export const mapCenter = { lat: 34.697, lng: 135.84539 };
export function createMap(elementId, zoom = 3) {
    if (Map) {
        resetMarkers();
    }
    const mapOptions = {
        streetViewControl: false,
        zoom: zoom,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        center: mapCenter,
        disableDefaultUI: true,
    };
    Map = new google.maps.Map(document.getElementById(elementId), mapOptions);
    markerClusterer = new MarkerClusterer(Map, markers, {
        imagePath: '',
    });
}
let markers = [];
let markerClusterer;
export function resetMarkers() {
    markers.forEach((item) => {
        // console.log({ item });
        // item.self.setMap(null);
        markerClusterer.removeMarker(item);
    });
    markers = [];
    markerClusterer.clearMarkers();
}
export function createMarker(service, moveCenter = false) {
    var _a, _b;
    const noImage = 'https://digitalfinger.id/wp-content/uploads/2019/12/no-image-available-icon-6-600x375.png';
    const markerClass = {
        0: 'fas fa-hotel',
        1: 'fas fa-skiing',
        2: 'fas fa-utensils',
        3: 'fas fa-shopping-basket',
    };
    const markerCard = `<div class='markerz-container' id='${service.Id}'>
                            <div class='markerz-card'><i class='${markerClass[service.Type]}'></i></div>
                            <div class='markerz-arrow'>T</div>
                        </div>`;
    const marker = new markerWithLabel.MarkerWithLabel({
        position: new google.maps.LatLng((_a = service.Geocode) === null || _a === void 0 ? void 0 : _a.latitude, (_b = service.Geocode) === null || _b === void 0 ? void 0 : _b.longitude),
        clickable: true,
        draggable: false,
        map: Map,
        optimized: false,
        labelContent: markerCard,
        labelAnchor: new google.maps.Point(-20, -50),
        labelClass: 'markerLabels',
        labelStyle: { opacity: 1.0 },
        icon: 'images/small.png',
        zIndex: 1,
    });
    marker.addListener('mouseover', function () {
        document.getElementById(service.Id).classList.add('rotate');
    });
    marker.addListener('mouseout', function () {
        document.getElementById(service.Id).classList.remove('rotate');
    });
    if (moveCenter) {
        Map.panTo(marker.getPosition());
    }
    const imageBackground = `background:linear-gradient(to bottom, 
    #00000052 40%, rgba(0 0 0 / 85%)), url('${service.Thumbnail}');`;
    const infoWindow = `
        <div class="info-window">
            <div class='card-wrapper'>          
                <div class='thumb-wrapper'>
                   <img src=${service.Thumbnail} alt='service thumbnail'>
                </div>
               <h4 class='info name'>${service.Name}</h4>
               <div class='info address'>${service.Address}</div>
               <div class='info price'> 
               ${getLanguage() !== 'ja' ? lang.from : ''} ¥${formatMoney(service.Price)} ${getLanguage() === 'ja' ? lang.from : ''}
               </div>
               ${!getUrlParam('id')
        ? `<div class='row-button'>
               <a class='first-button flex-1' href=${getDetailsUrl(service.Id, service.onRequestOnly)}>
                  ${lang.view_details}
               </a>
            </div>`
        : null}
               
          </div>
        </div>
    `;
    const infowindow = new google.maps.InfoWindow({
        content: infoWindow,
    });
    // const like = function () {
    //     wishlist.add(service);
    // };
    const checkIfAlreadyLiked = () => {
        isAlreadyLiked(service.Id);
    };
    marker.addListener('click', function () {
        infowindow.open(Map, marker);
        setTimeout(function () {
            const likeButton = document.getElementById('like-' + service.Id);
            // likeButton.removeEventListener('click', like);
            // likeButton.addEventListener('click', like);
            checkIfAlreadyLiked();
        }, 200);
    });
    //
    const index = markers.findIndex((marker) => marker.id == service.Id);
    if (index != -1) {
        // replace the existing
        markers[index] = { id: service.Id, self: marker, open, close };
    }
    else {
        //push to the stack
        markers.push({ id: service.Id, self: marker, open, close });
        markers.push(marker);
    }
    markers.push(marker);
    markerClusterer.addMarker(marker);
}
export const isAlreadyLiked = (serviceId) => {
    const likeButton = document.getElementById('like-' + serviceId);
    if (!likeButton)
        return;
    likeButton.innerText = wishlist.alreadyExist(serviceId)
        ? lang.remove_from_wishlist
        : lang.add_to_wishlist;
};
